import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-speaker-end-back',
  templateUrl: './speaker-end-back.component.html',
  styleUrls: ['./speaker-end-back.component.scss']
})
export class SpeakerEndBackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
